export default __webpack_public_path__ + "static/media/aleksei-bulgak-study.0cb7be35.jpg";